const pmeta = {
  "pmeta.min": "min.",
  "pmeta.anes_local": "Anesthésie locale",
  "pmeta.anes_general": "Anesthésie générale",
  "pmeta.anes_none": "Aucune",
  "pmeta.sessions_1": "1 rendez-vous",
  "pmeta.sessions_2": "2 rendez-vous",
  "pmeta.sessions_1_2": "1–2 rendez-vous",
  "pmeta.sessions_2_3": "2–3 rendez-vous",
  "pmeta.sessions_ongoing": "En continu",
};

export default pmeta;
